<template>
  <div>
    <h1>Relatórios</h1>
    <div class="content events">
      <div class="subtitle">
        <h2>Escolha um evento</h2>
      </div>
      <table>
        <thead>
          <tr>
            <th>Evento</th>
          </tr>
        </thead>
        <tbody>
          <tr class="event-link" v-for="event in events" :key="event.id">
            <td v-if="event.validate_amount != 0"><router-link :to="{ name: 'Report', params: {id: event.id} }">{{ event.name }}</router-link></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Reports',
  data () {
    return {
      events: []
    }
  },
  created () {
    this.$http.get(process.env.VUE_APP_URL_APP + '/b/events').then(res => {
      this.events = this.$_.orderBy(res.body, ['date'], ['desc'])
    }, err => {
      console.log(err)
    })
  }
}
</script>
